import {
  AuthCanvasDark,
  AuthCanvasLight,
  AuthLogo,
} from "@/constant/imagePath";
import { cn } from "@/helper/HelperFunction";
import classes from "./AuthLayout.module.css";

export default function AuthLayout({ children }) {
  return (
    <div className={classes.mainContainer}>
      <div className={classes.chilrenContainer}>{children}</div>
      <div className={classes.auth__wrapper}>
        <div className={classes.contentWrapper}>
          <div className={classes.logoWrapper}>
            <img src={AuthLogo} alt="Logo" />
          </div>
          <h1>Unlock Your Creative Flow with Stitchify</h1>
          <p>
            Stitchify is a seamless design platform for creating, collaborating,
            and prototyping with ease.
          </p>
        </div>
        <div className={classes.image}>
          <>
            <img
              src={AuthCanvasLight}
              alt="Login Image"
              className={cn(classes.loginImage, classes.lightImage)}
            />
            <img
              src={AuthCanvasDark}
              alt="Login Image"
              className={cn(classes.loginImage, classes.darkImage)}
            />
          </>
        </div>
      </div>
    </div>
  );
}
